import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from './../../requests/apa/Asset';
import Legals from '../../requests/apa/Legals';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import { TITLE_MODAL_TERM_AND_CONTIONS } from '../../AAF/Auth/authConstants'

import './styles/termAndCond.css';

const ModalTermAndCond = (props) => {
    const region = DeviceStorage.getItem('region');
    let content = Legals.get('tyc_full_text', region, '');
    content = content.replace(/<a/gi, "<a onClick='return false;'");

    if(typeof props.setMetricsEvent === 'function'){
      const sendDimension=()=>{
        const payload=new AnalyticsDimensionSingleton().getPayload();
        props.setMetricsEvent(payload);
        props.setMetricsEvent({ type: 'executor'});
      };
      const sendMetric=()=>{
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'errores',
          eventAction: TITLE_MODAL_TERM_AND_CONTIONS,
          eventLabel: content,
        });
        props.setMetricsEvent({type:'executor'});
        sendDimension();
      };
      sendMetric();
    }

    const getArrows = (align = '') => {
        return (
            <div className={`arrows ${align}`}>
                <a id="upTermAndCond" href="#" className={`input-up ${align}`}>
                    <i className="fa fa-chevron-up fa-3" aria-hidden="true" />
                </a>
                <a id="downTermAndCond" href="#" className={`input-down ${align}`}>
                    <i className="fa fa-chevron-down fa-3" aria-hidden="true" />
                </a>
            </div>
        );
    };
    const customizedClassName =`modal-button-return`;
    const p = {
        content,
        className: 'termAndCond blackBackground',
        yellowAction: (e) => props.handleClose(e, props.onShowAcceptTerm),
        colorButtons: [
          {
            content: Translator.get('top_head_option_button_back', 'REGRESAR'),
            props: {
              color: 'yellow',
              className: customizedClassName,
              imgSrc: Assets.get('top_head_option_back', ''),
              onClick: (e) => props.handleClose(e, props.callback)
            }
          }
        ],
        children: getArrows(props.align),
        callbackWhenBack: props.callbackWhenBack,
        aafNewStyle: true
    };

    return <ModalWrapper {...p} />;
};

export default withOnClose(ModalTermAndCond);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTermAndCond.jsx